export const featureFlags = {
  // Auto Recall
  autoRecallDemoData: 'auto-recall-analytics-demo-data',
  disableAutoRecallInAnalytics: 'disable-auto-recall-in-analytics',

  // Call Intel
  enableServiceQuality: 'enable-service-quality',
  enableCallIntelEditAi: 'enable-call-intel-edit-ai-output',
  editAiDesignVariant: 'edit-ai-output-design-variant',
  enableCallIntelDemoData: 'enable-call-intel-demo-data',
  enableTrueSchedulingStatus: 'enable-true-scheduling-status',
  enableTSSMulti: 'enable-multi-true-scheduling-status',
  enableEmailTemplateV2: 'call_intel_email_template_v2',

  // Practice
  practiceAnalyticsDemo: 'analytics-demo-data',

  // ROI
  appointmentRemindersRoiDemoData: 'appointment-reminders-roi-demo-data',
  bulkTextRoiDemoData: 'bulk-text-roi-demo-data',
  hideNoShowRate: 'hide-no-show-rate',
  hideRoiProductionValue: 'hide-roi-production-value',
  missedCallTextRoiDemoData: 'missed-call-text-roi-demo-data',
  noShowRateRoiDemoData: 'no-show-rate-roi-demo-data',

  // Reporting
  enableAnalyticsReporting: 'enable-analytics-reporting',
};
